import React from "react";
import moment from "moment";

const getAgendaCategory = (app) => {
  return app?.appointmentStatus?.agendatab?.replace(" Items", "") || "Pending";
};

const AgendaView = ({
  currentView,
  currentAgendaTab,
  setCurrentAgendaTab,
  appointments,
  miniSelectedDate,
}) => {
  if (currentView !== "agenda") return null;

  let filteredApps = [...appointments];

  if (miniSelectedDate) {
    filteredApps = filteredApps.filter((app) =>
      app.date?.startsWith(miniSelectedDate)
    );
  }

  // Filter by agenda tab based on `appointmentStatus.agendatab`
  filteredApps = filteredApps.filter(
    (app) => getAgendaCategory(app) === currentAgendaTab
  );

  filteredApps.sort((a, b) => {
    return (
      new Date(`${a.date}T${a.startTime || a.start}`) -
      new Date(`${b.date}T${b.startTime || b.start}`)
    );
  });

  const groupedByDate = filteredApps.reduce((groups, app) => {
    const dateKey = app.date?.split("T")[0] || "Unknown Date";
    if (!groups[dateKey]) groups[dateKey] = [];
    groups[dateKey].push(app);
    return groups;
  }, {});
  // console.log(groupedByDate,"groupedByDate=-=-=-")
  const getTimeUntilSession = (appDate, startTime) => {
    const now = moment();
    const sessionStart = moment(`${appDate} ${startTime}`, "YYYY-MM-DD HH:mm");

    if (!sessionStart.isValid()) return "Invalid date";

    const sessionEnd = sessionStart.clone().add(1, "hour");

    if (now.isAfter(sessionEnd)) {
      return "Session Completed";
    } else if (now.isAfter(sessionStart)) {
      return "Session already started";
    } else {
      const duration = moment.duration(sessionStart.diff(now));
      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      return `Session Starts in ${days} day${
        days !== 1 ? "s" : ""
      }, ${hours} hour${hours !== 1 ? "s" : ""}`;
    }
  };

  return (
    <div>
      <div className="agenda-tabs_CalendarView">
        {["Scheduled", "Finished", "Pending"].map((tab) => (
          <button
            key={tab}
            className={`agenda-tab_CalendarView ${
              currentAgendaTab === tab ? "active" : ""
            }`}
            onClick={() => setCurrentAgendaTab(tab)}
          >
            {tab} Items
          </button>
        ))}
      </div>

      <div className="agenda-view-container">
        {Object.keys(groupedByDate).length === 0 && (
          <p>No appointments found.</p>
        )}

        {Object.keys(groupedByDate).map((date) => (
          <div className="agenda-date-group" key={date}>
            <h3 style={{ textAlign: "left" }}>{date}</h3>
            {groupedByDate[date].map((app) => {
              const startTime = app.startTime || app.start || "00:00";
              const sessionTimeText = getTimeUntilSession(date, startTime);

              return (
                <div key={app._id} className="agenda-item">
                  <h4 style={{ textAlign: "left" }}>{startTime}</h4>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        className="agenda-details"
                        style={{ textAlign: "left" }}
                      >
                        <strong>Client:</strong>{" "}
                        {app.patientRequestId?.firstName}{" "}
                        {app.patientRequestId?.lastName} <br />
                        <strong>Provider:</strong>{" "}
                        {app.doctorRequestId?.firstName}{" "}
                        {app.doctorRequestId?.lastName}
                        <br />
                        <strong>Visit Reason:</strong>{" "}
                        {app.visitReason?.visitReason || "N/A"}
                        <br />
                        <strong>Type:</strong> {app.deliveryMode?.name || "N/A"}{" "}
                        | Status: {app?.appointmentStatus?.name || "Pending"}
                      </div>
                      <h2>{sessionTimeText}</h2>
                    </div>

                    {app.deliveryMode?.name?.trim().toLowerCase() ===
                      "telehealth" && (
                      <button
                        className="join-telehealth-btn"
                        style={{
                          height: 40,
                          width: 200,
                          border: "1px solid black",
                          color: "black",
                          // alignSelf:'flex-start'
                        }}
                      >
                        Join Telehealth
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AgendaView;
